import moment from 'moment';
import rdbClient from 'rdb-client';
import { getDeviationTypesRequest, getDeviationCausesRequest, updateDeviationTypeRequest, updateDeviationCauseRequest, newDeviationTypeRequest, newDeviationCauseRequest, deleteDeviationTypeRequest, deleteDeviationCauseRequest } from '../requests';

function setValue({ commit }, { value, key }) {
	commit('setValue', { value, key });
}

async function getDeviationTypes({ commit, state }) {
	commit('set', (state) => { state.loading = true; });
	try {
		let deviationTypes = await getDeviationTypesRequest();
		commit('set', () => { state.deviationTypes = deviationTypes; });
	} catch (err) {
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });
}

async function getDeviationCauses({ commit, state }) {
	commit('set', (state) => { state.loading = true; });
	try {
		let deviationCauses = await getDeviationCausesRequest();
		commit('set', () => { state.deviationCauses = deviationCauses; });
	} catch (err) {
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });
}

function setDeviationTypeTemplate({ state, commit }, template) {
	for (let key in state.deviationTypeTemplate) {
		if (key in template) {
			commit('set', (state) => { state.deviationTypeTemplate[key] = JSON.parse(JSON.stringify(template[key])); });
		}
	}
}

function setDeviationCauseTemplate({ state, commit }, template) {
	for (let key in state.deviationCauseTemplate) {
		if (key in template) {
			commit('set', (state) => { state.deviationCauseTemplate[key] = JSON.parse(JSON.stringify(template[key])); });
		}
	}
}

function setDeviationTypeEditId({ commit }, deviationTypeId) {
	commit('set', (state) => { state.deviationTypeEditId = deviationTypeId; });
}

function setDeviationCauseEditId({ commit }, deviationCauseId) {
	commit('set', (state) => { state.deviationCauseEditId = deviationCauseId; });
}

function showEditDeviationType({ commit }, shouldShow) {
	commit('set', (state) => { state.showEditDeviationType = shouldShow; });
}

function showEditDeviationCause({ commit }, shouldShow) {
	commit('set', (state) => { state.showEditDeviationCause = shouldShow; });
}

async function saveDeviationTypeTemplate({ state, commit }) {
	let newDeviationTypeTemplate = JSON.parse(JSON.stringify(state.deviationTypeTemplate));
	let oldDeviationTypeTemplate = state.deviationTypes.find(x => x.id === newDeviationTypeTemplate.id);

	if (oldDeviationTypeTemplate) {
		try {
			newDeviationTypeTemplate.editedDate.date = moment().format('YYYYMMDDHHmm');
			let patch = rdbClient.createPatch(oldDeviationTypeTemplate, newDeviationTypeTemplate);
			await updateDeviationTypeRequest(newDeviationTypeTemplate.id, { patch });
			let updatedDeviationTypes = [...state.deviationTypes];
			updatedDeviationTypes[updatedDeviationTypes.indexOf(oldDeviationTypeTemplate)] = newDeviationTypeTemplate;
			commit('set', () => { state.deviationTypes = updatedDeviationTypes; });
		} catch (err) {
			throw new Error('failedToUpdate');
		}
	} else {
		try {
			let response = await newDeviationTypeRequest(newDeviationTypeTemplate);
			newDeviationTypeTemplate.id = response.id;
			let deviationTypes = [...state.deviationTypes];
			deviationTypes.unshift(newDeviationTypeTemplate);
			commit('set', () => { state.deviationTypes = deviationTypes; });
		} catch (err) {
			throw new Error('failedToCreate');
		}
	}
	commit('resetDetails');
}

async function saveDeviationCauseTemplate({ state, commit }) {
	let newDeviationCauseTemplate = JSON.parse(JSON.stringify(state.deviationCauseTemplate));
	let oldDeviationCauseTemplate = state.deviationCauses.find(x => x.id === newDeviationCauseTemplate.id);

	if (oldDeviationCauseTemplate) {
		try {
			newDeviationCauseTemplate.editedDate.date = moment().format('YYYYMMDDHHmm');
			let patch = rdbClient.createPatch(oldDeviationCauseTemplate, newDeviationCauseTemplate);
			await updateDeviationCauseRequest(newDeviationCauseTemplate.id, { patch });
			let updatedDeviationCauses = [...state.deviationCauses];
			updatedDeviationCauses[updatedDeviationCauses.indexOf(oldDeviationCauseTemplate)] = newDeviationCauseTemplate;
			commit('set', () => { state.deviationCauses = updatedDeviationCauses; });
		} catch (err) {
			throw new Error('failedToUpdate');
		}
	} else {
		try {
			let response = await newDeviationCauseRequest(newDeviationCauseTemplate);
			newDeviationCauseTemplate.id = response.id;
			let deviationCauses = [...state.deviationCauses];
			deviationCauses.unshift(newDeviationCauseTemplate);
			commit('set', () => { state.deviationCauses = deviationCauses; });
		} catch (err) {
			throw new Error('failedToCreate');
		}
	}
	commit('resetDetails');
}

async function deleteDeviationTypes({ state, commit }, deviationTypesToDelete) {
	let storedDeviationTypes = state.deviationTypes;
	let idsToRemove = [];
	for (let dType of deviationTypesToDelete) {
		idsToRemove.push(dType.id);
	}
	try {
		for (let deviationTypeId of idsToRemove) {
			await deleteDeviationTypeRequest(deviationTypeId);
		}
		let updatedDeviationTypes = storedDeviationTypes.filter(term => idsToRemove.indexOf(term.id) < 0);
		commit('set', () => { state.deviationTypes = updatedDeviationTypes; });
	} catch (err) {
		throw new Error('failedToDelete');
	}
}

async function deleteDeviationCauses({ state, commit }, deviationCausesToDelete) {
	let storedDeviationCauses = state.deviationCauses;
	let idsToRemove = [];
	for (let dType of deviationCausesToDelete) {
		idsToRemove.push(dType.id);
	}
	try {
		for (let deviationCauseId of idsToRemove) {
			await deleteDeviationCauseRequest(deviationCauseId);
		}
		let updatedDeviationCauses = storedDeviationCauses.filter(term => idsToRemove.indexOf(term.id) < 0);
		commit('set', () => { state.deviationCauses = updatedDeviationCauses; });
	} catch (err) {
		throw new Error('failedToDelete');
	}
}

export default {
	setValue,
	getDeviationTypes,
	getDeviationCauses,
	setDeviationTypeEditId,
	setDeviationCauseEditId,
	setDeviationTypeTemplate,
	setDeviationCauseTemplate,
	showEditDeviationType,
	showEditDeviationCause,
	saveDeviationTypeTemplate,
	saveDeviationCauseTemplate,
	deleteDeviationTypes,
	deleteDeviationCauses,
};
